import makeList from './makeList.js'

let viewFloor = '光学観測棟'

let params = [
  {
    name: 'syowa',
    locations: [
      { description: '光学観測棟(1)',
        file: './data/I31a.JPG',
        rotation: -168.69548990340556,
        link: [
          {
            file: './data/I15.JPG',
            position: [ 4604.094872809356, 231.92523296167977, 1913.5498061028647 ],
          },
          {
            file: './data/I31b_2.JPG',
            position: [ -3108.015913347182, 275.03930301300255, 3894.272773636664 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 324.822695035461, 246.80851063829783 ],
          syowaZoom: [ 782.0512820512821, 184.79487179487194 ],
        },
      },
      { description: '光学観測棟(2)',
        file: './data/I31b_2.JPG',
        rotation: -19.505065769730166,
        link: [
          {
            file: './data/I31a.JPG',
            position: [ -3561.396111273126, 401.4780637750168, -3476.6783517963013 ],
          },
          {
            file: './data/I31c.JPG',
            position: [ 2270.334825495565, 468.435918482896, 4419.771922174388 ],
          },
          {
            file: './data/I31d.JPG',
            position: [ 21.563716855908645, 321.17878214405465, 4986.250541510702 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 324.822695035461, 246.80851063829783 ],
          syowaZoom: [ 764.1025641025642, 223.2564102564104 ],
        },
      },
      { description: '光学観測棟空調室',
        file: './data/I31c.JPG',
        rotation: -25.411127865739793,
        link: [
          {
            file: './data/I31b_2.JPG',
            position: [ -4158.645733408095, 1006.1422059002235, 2569.501206988445 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 324.822695035461, 246.80851063829783 ],
          syowaZoom: [ 705.1282051282052, 233.51282051282055 ],
        },
      },
      { description: '光学観測棟物入',
        file: './data/I31d.JPG',
        rotation: -122.13706516737255,
        link: [
          {
            file: './data/I31b_2.JPG',
            position: [ 3705.7411851668, -103.3483378269137, 3349.901384975978 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 324.822695035461, 246.80851063829783 ],
          syowaZoom: [ 805.1282051282052, 256.58974358974365 ],
        },
      },
      /*
       */
    ],
  },
]

export default makeList(params,viewFloor)
